import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';
import {
  ApiService,
  Conference,
  Cluster,
  DateTimeFrame,
  CLUSTERS
} from '../../../shared';
import { environment } from '../../../../environments/environment';

const SLIDE_INTERVAL: number = +environment.CLUSTER_SCHEDULE_SLIDE_INTERVAL;
const REFRESH_DELAY: number = 2000;


@Component({
  selector: 'app-cluster-schedule-page',
  templateUrl: './cluster-schedule-page.component.html',
  styleUrls: ['./cluster-schedule-page.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ClusterSchedulePageComponent implements OnInit {
  selectedTabIndex;
  clusters = CLUSTERS;
  cluster$: Observable<Cluster>;
  conferences$: Observable<Conference[]>;
  dataTimeFrame$: Observable<DateTimeFrame>;

  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.cluster$ = this.getCluster();
    this.conferences$ = this.getConferences();
    this.dataTimeFrame$ = this.getDateTimeFrame();
    this.selectedTabIndex = 0;
    this.slideView();
  }

  getCluster() {
    return this.apiService.getCluster(this.activatedRoute.snapshot.params['cluster']);
  }

  getConferences() {
    return this.apiService.getClusterConferences(this.activatedRoute.snapshot.params['cluster']);
  }

  getDateTimeFrame() {
    return this.apiService.getDateTimeFrame();
  }

  /**
   * 0 - schedule
   * 1 - map
   */
  slideView() {
    IntervalObservable.create(SLIDE_INTERVAL)
      .subscribe(() => {
        // refresh only when map is show
        if (this.selectedTabIndex == 0) {
          this.selectedTabIndex = 1;
          setTimeout(()=>{ this.refreshConferences() }, REFRESH_DELAY)
        } else {
          this.selectedTabIndex = 0;
        }
      });
  }

  refreshConferences() {
    this.conferences$ = this.getConferences();
  }
}



// WEBPACK FOOTER //
// ./src/app/schedule/pages/cluster-schedule-page/cluster-schedule-page.component.ts